import { Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StyledInfo from "./StyledInfo";
import TermsCondition from "./TermsCondition";
import PrivacyPolicy from "./PrivacyPolicy";
import { ROUTE_PATH } from "../../../constants/route";
import termsBackgroundImage from "../../../assets/images/terms-condition-bg.webp";
import privacyBackgroundImage from "../../../assets/images/privacy-policy-bg.webp";


const Info = ({ activeTab = 0 }) => {
  const navigate = useNavigate()
  const [currentTab, setCurrentTab] = useState(activeTab);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    navigate(`${newValue === 0 ? ROUTE_PATH.TERMS_AND_CONDITION : ROUTE_PATH.PRIVACY_POLICY}${searchParams.size === 1 ? `?mobile=true` : ''}`);
  };

  const tabComponents = [<TermsCondition />, <PrivacyPolicy />];
  const tabTitles = ["Terms and Conditions", "Privacy Policy"]

  useEffect(() => {
    const path = location.pathname;
    if (path.includes("terms")) {
      setCurrentTab(0);
    } else if (path.includes("privacy")) {
      setCurrentTab(1);
    }
  }, [location.pathname]);

  return (
    <StyledInfo>
      <Box>
        <Box className="info-header" style={{ backgroundImage: `url(${currentTab === 0 ? termsBackgroundImage : privacyBackgroundImage})` }}>
          <Box className="info-text">
            <Typography className="text-heading">
               {tabTitles[currentTab]}
            </Typography>
            <Typography className="text-body">
              Last Updated Jul 1, 2025
            </Typography>
          </Box>
        </Box>
        <Box className="tabs">
          <Tabs value={currentTab} onChange={handleTabChange}>
            <Tab label={tabTitles[0]} />
            <Tab label={tabTitles[1]} />
          </Tabs>
        </Box>
        <Box>{tabComponents[currentTab]}</Box>
      </Box>
    </StyledInfo>
  );
};

export default Info;
